export enum UserPreference {
    LAST_ACCESSED_CAMPAIGN = "last_accessed_campaign",
    OPENING_DZI_FROM_RESULTS_LIST_SELECTS_IMAGE = "opening_dzi_from_results_list_selects_image",
    LAST_SELECTED_BASE_MAP = "last_selected_base_map",
    LAST_DZI_CAROUSEL_STATE = "last_dzi_carousel_state",
    VIEW_ASSET_IN_2D = "view_asset_in_2d",
}